import {easeOut} from 'ol/easing'
import proj4 from 'proj4'
import { EPSG_28355, EPSG_28356 } from './projections'

proj4.defs('EPSG:28356', EPSG_28356)
proj4.defs('EPSG:28355', EPSG_28355)

export const zoomByDelta = (map, delta) => {
  let view = map.getView()
  if (!view) {
    // the map does not have a view, so we can't act
    // upon it
    return
  }
  let currentResolution = view.getResolution()
  if (currentResolution) {
    let newResolution = view.constrainResolution(currentResolution, delta)
    if (view.getAnimating()) {
      view.cancelAnimations()
    }
    view.animate({
      resolution: newResolution,
      duration: 250,
      easing: easeOut
    })
  }
}

export const transformGeometry = (geom, sourceSrs, destSrs) => {

  let t = (coords) => {
    if (typeof coords[0] === 'number') {
      let ct = proj4(proj4(sourceSrs),  proj4(destSrs)).forward(coords)
      coords[0] = ct[0]
      coords[1] = ct[1]
    } else {
      coords.forEach(c => t(c))
    }
  }
  let coordinates = geom.getCoordinates()
  t(coordinates)
  geom.setCoordinates(coordinates)
  return geom
}



// WEBPACK FOOTER //
// ./src/util/map.js